module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-4__18dc83964ecea35d3316a1a22cdd5610.png";